import { createFileRoute } from "@tanstack/react-router";
import AetnaMaInsurance, { config } from "@/pages/AetnaMaInsurance";
import { buildInsuranceSchema } from "@/components/InsurancePageTemplate";
export const Route = createFileRoute("/aetna-ma-insurance")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Aetna Medicare Advantage TMS Coverage | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Have Aetna Medicare Advantage? Learn about TMS therapy, SAINT TMS, and depression treatment options that may be available through your Aetna MA plan in.",
        },
        {
          property: "og:title",
          content: "Aetna Medicare Advantage TMS Coverage | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Have Aetna Medicare Advantage? Learn about TMS therapy, SAINT TMS, and depression treatment options that may be available through your Aetna MA plan in.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/aetna-ma-insurance",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/aetna-ma-insurance",
        },
      ],
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(buildInsuranceSchema(config)),
        },
      ],
    };
  },
});
function RouteComponent() {
  return <AetnaMaInsurance />;
}
